// Part names for the gallery plates, keyed by the file name in /public.
// Visible facts only: what the photo shows. Never the brand printed on a part,
// never the process that printed it, never a customer.

export const GALLERY_LOCALES = ['tr', 'en', 'de']

export const PORTFOLIO_CAPTIONS = {
  'portfolio-new-1.webp': {
    tr: 'ISOFIX kılavuzu, bej',
    en: 'ISOFIX guide, beige',
    de: 'ISOFIX-Führung, beige'
  },
  'portfolio-7.webp': {
    tr: 'ISOFIX kılavuzu, siyah',
    en: 'ISOFIX guide, black',
    de: 'ISOFIX-Führung, schwarz'
  },
  'portfolio-10.webp': {
    tr: 'Flanşlı ISOFIX kılavuzu',
    en: 'ISOFIX guide with flange',
    de: 'ISOFIX-Führung mit Flansch'
  },
  'portfolio-9.webp': {
    tr: 'ISOFIX kılavuzu, dikdörtgen',
    en: 'ISOFIX guide, rectangular',
    de: 'ISOFIX-Führung, rechteckig'
  },
  'portfolio-new-4.webp': {
    tr: 'ISOFIX kapağı',
    en: 'ISOFIX cover',
    de: 'ISOFIX-Abdeckung'
  },
  'portfolio-11.webp': {
    tr: 'ISOFIX kapağı, yuvarlak',
    en: 'ISOFIX cover, rounded',
    de: 'ISOFIX-Abdeckung, gerundet'
  },
  'portfolio-12.webp': {
    tr: 'SOFIX kapağı',
    en: 'SOFIX cover',
    de: 'SOFIX-Abdeckung'
  },
  'portfolio-5-v3.webp': {
    tr: 'TOP TETHER kapağı',
    en: 'TOP TETHER cover',
    de: 'TOP-TETHER-Abdeckung'
  },
  'portfolio-2.webp': {
    tr: 'Kombi kontrol paneli, skala',
    en: 'Combi-boiler control panel, scale',
    de: 'Kombitherme-Bedienfeld, Skala'
  },
  'portfolio-3.webp': {
    tr: 'Cihaz ön paneli',
    en: 'Appliance front panel',
    de: 'Geräte-Frontblende'
  },
  'montaj-1.webp': {
    tr: 'Kauçuk profil',
    en: 'Rubber profile',
    de: 'Gummiprofil'
  },
  'montaj-2.webp': {
    tr: 'Kablolu metal braket çifti',
    en: 'Metal bracket pair with cable',
    de: 'Metallhalter-Paar mit Kabel'
  }
}

// Interface strings for the gallery and its viewer.
export const GALLERY_LABELS = {
  tr: {
    gallery: 'Galeri',
    enlarge: 'büyüt',
    close: 'Kapat',
    prev: 'Önceki görsel',
    next: 'Sonraki görsel',
    part: 'Parça'
  },
  en: {
    gallery: 'Gallery',
    enlarge: 'enlarge',
    close: 'Close',
    prev: 'Previous image',
    next: 'Next image',
    part: 'Part'
  },
  de: {
    gallery: 'Galerie',
    enlarge: 'vergrößern',
    close: 'Schließen',
    prev: 'Vorheriges Bild',
    next: 'Nächstes Bild',
    part: 'Teil'
  }
}

export function resolveGalleryLocale(lang) {
  return GALLERY_LOCALES.includes(lang) ? lang : 'tr'
}

/** Caption for a file; unknown files get a neutral numbered name ("Parça 3"). */
export function getPortfolioCaption(file, lang, index) {
  const locale = resolveGalleryLocale(lang)
  const entry = PORTFOLIO_CAPTIONS[file]
  if (entry) return entry[locale]
  return `${GALLERY_LABELS[locale].part} ${index + 1}`
}
